import { render, staticRenderFns } from "./ProductListView.vue?vue&type=template&id=22fd6f93&scoped=true"
import script from "./ProductListView.vue?vue&type=script&lang=js"
export * from "./ProductListView.vue?vue&type=script&lang=js"
import style0 from "./ProductListView.vue?vue&type=style&index=0&id=22fd6f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd6f93",
  null
  
)

export default component.exports